import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/jb-button-back/jb-button-back.css.ts
var jb_button_back_css_default = i`span span{font-family:var(--theme-font-bold-family, VerlagSSm, Tahoma, sans-serif);font-weight:var(--theme-font-bold-weight, 700)}span span{color:rgb(var(--rgb-primary, 20, 30, 85));font-size:.688rem;letter-spacing:.063rem;line-height:1rem}span{align-items:center;block-size:15px;cursor:pointer;display:flex;gap:18px;inline-size:fit-content}span jb-arrow-icon{fill:#141e55}span span{color:#141e55;text-transform:uppercase}span.white jb-arrow-back-icon{--stroke-color: #fff}span.white span{color:#fff}`;

export {
  jb_button_back_css_default
};
